<div id="certificate" #certificate>
  <h2>{{ 'frontpage.dashboard_tabs_personal_label' | translate }}</h2>
  <table>
    <tr>
      <td>{{ 'certificates.first_name' | translate }}:</td>
      <td>{{ documents.certificate.content.graduate.firstName }}
        @if (isNewFirstName) {
          <span class="current">
            ({{ 'certificates.current_registry' | translate }}
          {{ documents.certificate.content.currentOwnerData.firstName }})</span>
        }
      </td>
    </tr>
    <tr>
      <td>{{ 'certificates.last_name' | translate }}:</td>
      <td>{{ documents.certificate.content.graduate.lastName }}
        @if (isNewLastName) {
          <span class="current">
            ({{ 'certificates.current_registry' | translate }}
          {{ documents.certificate.content.currentOwnerData.lastName }})</span>
        }
      </td>
    </tr>
    <tr>
      <td>{{ 'finaldocument.idcode' | translate }}:</td>
      <td>{{ documents.certificate.content.graduate.idCode | idCode }}
        @if (isNewIDCode) {
          <span class="current">
            ({{ 'certificates.current_registry' | translate }}
          {{ documents.certificate.content.currentOwnerData.idCode | idCode }})</span>
        }
      </td>
    </tr>
  </table>
  <h2>{{ 'finaldocuments.data' | translate }}</h2>
  <table>
    <tr>
      <td>{{ 'finaldocuments.number' | translate }}:</td>
      <td>{{ documents.certificate.content.registrationNumber }}</td>
    </tr>
    <tr>
      <td>{{ 'finaldocuments.date_of' | translate }}:</td>
      <td>{{ issueDate }}</td>
    </tr>
    @if (documents.certificate.content.duplicateCertificateNumber) {
      <tr>
        <td>{{ 'finaldocuments.duplicate_number' | translate }}:</td>
        <td>{{ documents.certificate.content.duplicateCertificateNumber }}</td>
      </tr>
    }
    @if (documents.certificate.content.duplicateIssueDate) {
      <tr>
        <td>{{ 'finaldocuments.date_of_duplicate' | translate }}:</td>
        <td>{{ documents.certificate.content.duplicateIssueDate }}</td>
      </tr>
    }
  </table>
  @if (documents.certificate.content.educationalInstitutions?.length) {
    <h2>{{ 'finaldocuments.institution_data' | translate }}</h2>
    <table>
      <tr>
        <td>{{ 'finaldocuments.institution_name' | translate }}:</td>
        <td>{{ eduInst }}</td>
      </tr>
    </table>
  }
  <h2>{{ 'finaldocuments.curriculum_data' | translate }}</h2>
  <table>
    <tr>
      <td>{{ 'finaldocuments.curriculum_name' | translate }}:</td>
      <td>{{ documents.certificate.content.studies.curriculumName }}</td>
    </tr>
    <tr>
      <td>{{ 'finaldocuments.curriculum_code' | translate }}:</td>
      <td>{{ documents.certificate.content.studies.curriculumCode }}</td>
    </tr>
    @if (documents.certificate.content.studies.academicDegree) {
      <tr>
        <td>{{ 'finaldocuments.degree_name' | translate }}:</td>
        <td>{{ documents.certificate.content.studies.academicDegree }}</td>
      </tr>
    }
    @if (documents.certificate.content.studies.levelOfEducation) {
      <tr>
        <td>{{ 'finaldocuments.level_of_education' | translate }}:</td>
        <td>{{ documents.certificate.content.studies.levelOfEducation }}</td>
      </tr>
    }
    @if (documents.certificate.content.studies.accreditationDecision) {
      <tr>
        <td>{{ 'finaldocuments.accreditation_decision' | translate }}:</td>
        <td>{{ documents.certificate.content.studies.accreditationDecision }}</td>
      </tr>
    }
    @if (documents.certificate.content.studies.accreditationEndDate) {
      <tr>
        <td>{{ 'finaldocuments.accreditation_end_date' | translate }}:</td>
        <td>{{ documents.certificate.content.studies.accreditationEndDate }}</td>
      </tr>
    }
    @if (documents.certificate.content.studies.rightToProvideEducationDecision) {
      <tr>
        <td>{{ 'finaldocuments.right_to_provide_education_decision' | translate }}:</td>
        <td>{{ documents.certificate.content.studies.rightToProvideEducationDecision }}</td>
      </tr>
    }
    @if (documents.certificate.content.studies.rightToProvideEducationEndDate) {
      <tr>
        <td>{{ 'finaldocuments.right_to_provide_education_end_date' | translate }}:</td>
        <td>{{ documents.certificate.content.studies.rightToProvideEducationEndDate }}</td>
      </tr>
    }
    @if (documents.certificate.content.studies.typeOfTraining) {
      <tr>
        <td>{{ 'finaldocuments.type_of_training' | translate }}:</td>
        <td>{{ documents.certificate.content.studies.typeOfTraining }}</td>
      </tr>
    }
    @if (documents.transcript?.content?.studies?.creditPoint) {
      <tr>
        <td>{{ 'finaldocuments.credit_point' | translate }}:</td>
        <td>{{ documents.transcript.content.studies.creditPoint }}</td>
      </tr>
    }
    @if (documents.transcript?.content?.studies?.officialLengthOfProgramme) {
      <tr>
        <td>{{ 'finaldocuments.length_of_programme' | translate }}:</td>
        <td>{{ documents.transcript.content.studies.officialLengthOfProgramme }}</td>
      </tr>
    }
    @if (documents.supplement?.content?.studies?.creditPoint) {
      <tr>
        <td>{{ 'finaldocuments.credit_point' | translate }}:</td>
        <td>{{ documents.supplement.content.studies.creditPoint }}</td>
      </tr>
    }
    @if (documents.supplement?.content?.studies?.officialLengthOfProgramme) {
      <tr>
        <td>{{ 'finaldocuments.length_of_programme' | translate }}:</td>
        <td>{{ documents.supplement.content.studies.officialLengthOfProgramme }}</td>
      </tr>
    }
    @if (documents.certificate?.content?.qualificationWithinCurrentFramework) {
      <tr>
        <td>{{ 'finaldocuments.qualification_within_framework' | translate }}:</td>
        <td>{{ documents.certificate.content.qualificationWithinCurrentFramework }}</td>
      </tr>
    }
    @if (documents.supplement?.content?.levelOfQualification?.europeanQualificationFrameworkLevel) {
      <tr>
        <td>{{ 'finaldocuments.european_qualification_level' | translate }}:</td>
        <td>{{ documents.supplement.content.levelOfQualification.europeanQualificationFrameworkLevel }}</td>
      </tr>
    }
  </table>
</div>
